import { fetch as apiFetch } from '../fetchWrapper/fetch';
import { MARKETPLACE_API_URL } from '../constants';

export interface InitiateAuthResponse {
  type: 'auth_initiate';
  data: {
    authenticated: boolean;
    authUrl?: string;
  };
}

export const initiateAuth = async (addonId: string): Promise<InitiateAuthResponse> => {
  const response = await apiFetch(`${MARKETPLACE_API_URL}/addons/${addonId}/auth/initiate`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(response.statusText);
  }

  return response.json();
};
